import React, { useEffect, useState } from 'react';
import AppErrorState from './AppErrorState';
import {
  clearAppRuntimeError,
  getAppRuntimeError,
  installGlobalAppErrorHandlers,
  subscribeAppRuntimeError,
} from '../helpers/appRuntime';

const AppRuntimeGuard = ({ children }) => {
  const [runtimeError, setRuntimeError] = useState(() => getAppRuntimeError());

  useEffect(() => {
    installGlobalAppErrorHandlers();
    const unsubscribe = subscribeAppRuntimeError((nextError) => {
      setRuntimeError(nextError);
    });
    return unsubscribe;
  }, []);

  if (runtimeError) {
    return (
      <AppErrorState
        title='控制台运行异常'
        error={runtimeError}
        fullscreen
        onRetry={() => {
          clearAppRuntimeError();
        }}
        onReload={() => window.location.reload()}
        retryLabel='关闭错误提示'
        reloadLabel='刷新当前页'
      />
    );
  }

  return children;
};

export default AppRuntimeGuard;
